<div [ngClass]="{'pe-countdown':true,'pe-no-margin':item.data.fullWidth}"
     [ngStyle]="{  maxWidth:layoutSetting.maxWidth + 'px'}">
  <app-sub-component-container [layoutSetting]="layoutSetting" [item]="item">
    <div class="pe-s-slide-area">
      <div *ngFor="let slide of item.data.images;index as slideIndex"
           [ngClass]="{'pe-s-slide':true,'active':slide.active}"
           [ngStyle]="{backgroundImage:addUrl(slide.image),
                 left:(100*slideIndex)+'%',
                 transform:'translateX('+slide.translateX + '%)'}">
      </div>
      <h1 class="slider-headings">
        {{ item.data.Heading | uppercase  }}
        <br />
        <small>{{item.data.SubHeading}}</small>
      </h1>
      <div class="pe-s-prev" (click)="prevSlide()">
        <i class="fa fa-arrow-circle-o-left"></i>
      </div>

      <div class="pe-s-next" (click)="nextSlide()">
        <i class="fa fa-arrow-circle-o-right"></i>
      </div>

      <!--            <div class="dots">-->
      <!--              <div class="dot active"></div>-->
      <!--              <div class="dot"></div>-->
      <!--            </div>-->
    </div>
  </app-sub-component-container>

</div>
